<div class="flex-column" style="width: 44em; max-width: 92vw; height: 46em; max-height: 88vh;">

	<div class="flex-row flex-static" style="gap: .5em; align-items: flex-start;">
		<h2 class="modal-title" style="flex: 1 1 auto;">
			{{ modal_title() | trans }}
			@if (visit?.shelf_visit_id) {
			<span style="opacity: .6; font-size: 80%;">#{{ visit.shelf_visit_id }}</span>
			}
		</h2>
		@if (show_no_show() || show_delete()) {
			<div class="flex-row align-center" style="gap: .35em; margin-top: .5em;">
				@if (show_no_show()) {
					<button class="round filled" color="warn" (click)="do_no_show()" [title]="'PUNJENJE.NO_SHOW_BTN' | trans">
						<i icon="do_not_disturb"></i>
					</button>
				}
				@if (show_delete()) {
					<button class="round filled" color="warn" (click)="do_delete()" [title]="'PUNJENJE.DELETE_BTN' | trans">
						<i icon="delete"></i>
					</button>
				}
			</div>
		}
	</div>

	@if (is_editable() && !plan_locked()) {
		<p class="flex-static" style="font-size: 95%; text-align: end; color: rgb(var(--warn)); margin: 0 0 1em;">
			<span style="animation: blink 1s infinite forwards;">*</span>&nbsp;{{ 'REQUIRED_FILEDS' | trans }}
		</p>
	}

	@if (is_editable() && !is_edit) {
		<div class="plan-tabs flex-static">
			<button [class.active]="mode === 'single'" (click)="set_mode('single')">{{ 'PUNJENJE.FORM.MODE_SINGLE' | trans }}</button>
			<button [class.active]="mode === 'batch'" (click)="set_mode('batch')">{{ 'PUNJENJE.FORM.MODE_BATCH' | trans }}</button>
		</div>
	}

	<div class="flex-column" style="overflow: auto; flex: 1 1 auto; gap: 1em; min-height: 0; scrollbar-gutter: stable;">

		@if (is_editable()) {
			<div class="field-grid" form-collector style="margin-bottom: .5em;">
					@if (plan_locked()) {
						<div class="whole-row" style="opacity: .7; display: flex; align-items: center; gap: .4em;"><i icon="lock"></i> {{ lock_message() | trans }}</div>
					}

				@if (!is_supplier_admin) {
					<knw-auto-search class="whole-row"
						[function]="search_suppliers"
						[to-label]="format_supplier_name"
						label="{{ 'PUNJENJE.FORM.SUPPLIER' | trans }}"
						[ngModel]="supplier" (ngModelChange)="on_supplier_change($event)" [disabled]="plan_locked()"
						[classes]="'outlined'"
						[popover-width]="'auto'"
						[required]="true">
					</knw-auto-search>
				}

				<knw-auto-search class="whole-row"
					[function]="search_locations"
					[to-label]="format_location_name"
					label="{{ 'PUNJENJE.FORM.STORE' | trans }}"
					[(ngModel)]="location" [disabled]="plan_locked()"
					[classes]="'outlined'"
					[popover-width]="'auto'"
					[required]="true">
				</knw-auto-search>

				<div class="whole-row type-group">
					<span class="type-group-label">{{ 'PUNJENJE.FORM.TYPES' | trans }}</span>
					<div class="flex-row wrappable" style="gap: 1em;">
						@for (opt of work_type_options; track opt.id) {
							<label class="checkbox-input">
								<input type="checkbox" [(ngModel)]="opt.selected" [disabled]="plan_locked()" />
								<span>{{ opt.trans | trans }}</span>
							</label>
						}
					</div>
					@if (!type_valid()) {
						<span class="type-hint">{{ 'PUNJENJE.FORM.TYPE_REQUIRED' | trans }}</span>
					}
				</div>

				@if (is_edit || mode === 'single') {
					<task-date-picker-input [classes]="'outlined'" [required]="true" [label]="'PUNJENJE.FORM.DATE' | trans" [(ngModel)]="single_date" [disabled]="plan_locked()"></task-date-picker-input>
					<task-time-picker-input [classes]="'outlined'" [label]="'PUNJENJE.FORM.TIME' | trans" [(ngModel)]="single_time" [disabled]="plan_locked()"></task-time-picker-input>
				} @else {
					<div class="whole-row type-group-label" style="opacity: .7;">{{ 'PUNJENJE.FORM.BATCH_HINT' | trans }}</div>
					<div class="whole-row batch-helper">
						<task-date-picker-input [classes]="'outlined flex-dynamic'" [label]="'PUNJENJE.FORM.WEEK_START' | trans" [(ngModel)]="week_start"></task-date-picker-input>
						<button (click)="add_week()" [disabled]="!week_start"><i icon="date_range"></i> {{ 'PUNJENJE.FORM.ADD_WEEK' | trans }}</button>
						<button (click)="add_month()" [disabled]="!week_start"><i icon="calendar_month"></i> {{ 'PUNJENJE.FORM.ADD_MONTH' | trans }}</button>
					</div>
					<div class="whole-row">
						<button (click)="add_row()" style="width: 100%; justify-content: center;"><i icon="add"></i> {{ 'PUNJENJE.FORM.ADD_TERM' | trans }}</button>
					</div>
					@if (!rows.length) { <div class="whole-row type-hint">{{ 'PUNJENJE.FORM.NO_ROWS' | trans }}</div> }
					@for (row of rows; track $index) {
						<div class="whole-row batch-row">
							<task-date-picker-input [classes]="'outlined flex-dynamic'" [required]="true" [label]="'PUNJENJE.FORM.DATE' | trans" [(ngModel)]="row.date"></task-date-picker-input>
							<task-time-picker-input [classes]="'outlined flex-dynamic'" [label]="'PUNJENJE.FORM.TIME' | trans" [(ngModel)]="row.time"></task-time-picker-input>
							<button class="round" color="warn" (click)="remove_row($index)" [title]="'PUNJENJE.DELETE_BTN' | trans"><i icon="delete"></i></button>
						</div>
					}
				}

				<knw-auto-search class="whole-row"
					[function]="search_workers"
					[to-label]="format_worker_name"
					label="{{ 'PUNJENJE.FORM.WORKERS' | trans }}"
					[(ngModel)]="planned_workers" [disabled]="!workers_enabled()"
					[classes]="'outlined'"
					[multi]="true"
					[popover-width]="'auto'">
				</knw-auto-search>
				@if (!plan_locked() && !workers_enabled()) {
					<span class="whole-row type-hint">{{ 'PUNJENJE.FORM.WORKERS_PICK_SUPPLIER' | trans }}</span>
				}

				@if (plan_locked()) {
					<div class="whole-row locked-note">
						<span class="type-group-label">{{ 'PUNJENJE.FORM.NOTE' | trans }}</span>
						<p>{{ note?.trim() || '—' }}</p>
					</div>
				} @else {
					<label class="input outlined whole-row" [title]="'PUNJENJE.FORM.NOTE' | trans">
						<textarea [(ngModel)]="note"></textarea>
					</label>
				}
			</div>
		} @else {
			<task-entity-info
				[class.hide-heading]="is_visit_only()"
				[title]="!is_visit_only() && { text: entity_title() }"
				[tiles]="tiles()"
				[properties]="{
					'PUNJENJE.DETAIL.STORE': store_label(),
					'PUNJENJE.DETAIL.DATE': visit?.planned_visit_date ? (visit.planned_visit_date | datefmt : 'short_date' : false) : null,
					'PUNJENJE.DETAIL.TIME': visit ? fmt_time_str(visit.planned_visit_time) : null,
					'PUNJENJE.DETAIL.TYPES': type_names_str(),
					'PUNJENJE.DETAIL.NOTE': visit ? visit.planned_note : null
				}">
			</task-entity-info>

			@if (visit?.planned && visit?.planned_workers?.length) {
				<div class="grid-card">
					<div class="card-header"><h3 class="card-header-title">{{ 'PUNJENJE.DETAIL.PLANNED_WORKERS' | trans }}</h3></div>
					<div class="card-body">
						<div class="flex-row wrappable" style="gap: .5em;">
							@for (w of visit.planned_workers; track w.shelf_planned_worker_id) {
								<span class="label-pill">{{ w.first_name }} {{ w.last_name }}</span>
							}
						</div>
					</div>
				</div>
			}
		}

		@if (has_execution() && visit) {
			<div class="grid-card">
				<div class="card-header">
					<h3 class="card-header-title">
						<i [attr.icon]="status_struct(visit.status_id).icon" [style.color]="status_struct(visit.status_id).color"></i>
						{{ status_struct(visit.status_id).status_name }}
					</h3>
				</div>
				<div class="card-body">
					<div class="flex-column" style="gap: .4em;">
						<span><strong>{{ 'PUNJENJE.DETAIL.CHECK_IN' | trans }}:</strong> {{ visit.check_in_time ? (visit.check_in_time | datefmt : 'short_date_time' : false) : '—' }}</span>
						<span><strong>{{ 'PUNJENJE.DETAIL.CHECK_OUT' | trans }}:</strong> {{ visit.check_out_time ? (visit.check_out_time | datefmt : 'short_date_time' : false) : '—' }}</span>

						@if (visit.note?.trim()) {
							<span class="note-text"><strong>{{ 'PUNJENJE.DETAIL.COMPLETION_NOTE' | trans }}:</strong> {{ visit.note }}</span>
						}

						@if (work_items().length) {
							<strong style="margin-top: .25em;">{{ 'PUNJENJE.DETAIL.WORK_ITEMS' | trans }}</strong>
							@for (w of work_items(); track w.shelf_visit_work_item_id) {
								<div class="flex-column" style="gap: .1em;">
									<span>{{ work_type_name(w.work_type_id) }} — {{ w.hours }} {{ 'PUNJENJE.DETAIL.HOURS' | trans }} · {{ w.no_of_workers }} {{ 'PUNJENJE.DETAIL.WORKERS_UNIT' | trans }}</span>
									@if (w.comment?.trim()) {
										<span><strong>{{ 'COMMENT' | trans }}:</strong> {{ w.comment }}</span>
									}
								</div>
							}
							<span><strong>{{ 'PUNJENJE.DETAIL.TOTAL' | trans }}:</strong> {{ visit_hours() }} {{ 'PUNJENJE.DETAIL.HOURS' | trans }}@if (visit.total_no_of_workers != null) { · {{ visit.total_no_of_workers }} {{ 'PUNJENJE.DETAIL.WORKERS_UNIT' | trans }}}</span>
						}
					</div>
				</div>
			</div>
		}
	</div>

	<div class="flex-row flex-static modal-footer">
		@if (is_editable()) {
			<button color="primary" (click)="cancel()"><i icon="clear"></i><span>{{ 'CANCEL' | trans }}</span></button>
			<button class="filled" color="secondary" (click)="done()" [disabled]="!can_save() || plan_locked()"><i icon="check"></i><span>{{ (is_edit ? 'SAVE' : 'CREATE') | trans }}</span></button>
		} @else {
			<button class="filled" color="secondary" (click)="cancel()"><i icon="clear"></i><span>{{ 'PUNJENJE.CLOSE' | trans }}</span></button>
		}
	</div>
</div>

